import React, { useState } from "react";
import { FaSpinner, FaTimes } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { BsExclamationLg } from "react-icons/bs";

import { FaRegSquareCheck } from "react-icons/fa6";

import { pushNotifyUser } from "../../../redux/slices/pushSlice";
import {
  approveIsusuAdminPayment,
  fetchIsusuDefaulter,
} from "../../../redux/slices/isusuSlice";

export default function ModalIsusuAdminPayment({
  username,
  amount,
  group_id,
  user_id,
}) {
  const [showModal, setShowModal] = useState(false);

  const status = useSelector((state) => state.withdrawal?.status);

  const isusus = useSelector((state) => state.isusu?.isusu);
  const dispatch = useDispatch();

  const getGroupDataFromGroupId = (groupId) => {
    const isusu = isusus?.find((isusu) => +isusu.id === +groupId);

    return isusu
      ? {
          name: isusu.name || "No Group",
        }
      : { name: "No Group" };
  };

  const handleSubmit = async () => {
    try {
      const res = await dispatch(
        approveIsusuAdminPayment({
          user_id,
          amount,
          group_id: +group_id,
          username,
        })
      );
      if (res.payload) {
        const pushNote = {
          user_id: [user_id],
          title: "Capfields Evolve",
          body: `Hurray🎉 Capfields has paid your Isusu Contribution.`,
          click: "USER",
        };

        await dispatch(pushNotifyUser(pushNote));
        toast.success(res.payload.message);
        dispatch(fetchIsusuDefaulter());
      }
    } catch (error) {
      console.error(error);
    }

    setShowModal(false);
  };

  return (
    <>
      <div className=" flex items-center">
        <button
          type="button"
          onClick={() => setShowModal(true)}
          className="font-medium"
        >
          <FaRegSquareCheck className="text-green-600 text-lg" />
        </button>
      </div>
      {showModal ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-auto my-6 mx-auto max-w-5xl">
              <div className="border-0 rounded-lg p-12 shadow-lg relative flex flex-col bg-white outline-none focus:outline-none">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center"
                >
                  <FaTimes className="text-gray-300  text-xl" />
                  <span className="sr-only">Close modal</span>
                </button>
                <div className=" text-center mb-4">
                  <h1 className="text-2xl text-gray-800 text-center font-medium">
                    Isusu Admin Payment
                  </h1>
                  <p>Do you want to Approve this Isusu Admin Payment</p>
                </div>
                <div className="flex justify-center items-center m-2">
                  <BsExclamationLg className="text-gray-500 text-3xl font-bold" />
                </div>
                <div className="flex items-center justify-center px-8 py-4 gap-6">
                  <div className="flex flex-col gap-4">
                    <div className="flex flex-row gap-2 justify-between items-center">
                      <h1 className="text-[14px] text-left text-gray-400 ">
                        Name :
                      </h1>
                      <div className="">
                        <p className=" text-base font-bold">{username}</p>
                      </div>
                    </div>
                    <div className="flex flex-row gap-2 justify-between items-center">
                      <h1 className="text-[14px] text-left text-gray-400 ">
                        Amount :
                      </h1>
                      <div className="flex justify-center items-center">
                      <span className="mr-1">&#8358;</span>
                        <p className=" text-base font-bold">{amount}</p>
                      </div>
                    </div>
                    <div className="flex flex-row gap-2 justify-between items-center">
                      <h1 className="text-[14px] text-left text-gray-400 ">
                        Group :
                      </h1>
                      <div className="">
                        <p className=" text-base font-bold">
                          {getGroupDataFromGroupId(group_id).name}
                        </p>
                      </div>
                    </div>

                    <div className="flex mt-2 gap-4 justify-center">
                      <button
                        onClick={() => setShowModal(false)}
                        className="text-sm text-gray-500 font-semibold bg-gray-100 py-2 px-4 rounded-md"
                      >
                        Cancel
                      </button>
                      <button
                        className="flex gap-1 rounded-md items-center bg-green-600 text-white py-2 px-4"
                        disabled={status === "loading"}
                        onClick={handleSubmit}
                      >
                        {status === "loading" ? (
                          <>
                            <FaSpinner className="animate-spin" />
                            <p className="text-sm font-semibold whitespace-nowrap">
                              Approving ...
                            </p>
                          </>
                        ) : (
                          <>
                            <FaTimes className="w-4 h-4" />
                            <p className="text-sm font-semibold whitespace-nowrap">
                              Approve
                            </p>
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
}
